import { UPDATE_PARKING_EVENTS } from "./parkingEventsReducer";

export const updateParkingEvents = (events) => {
    return {
        type: UPDATE_PARKING_EVENTS,
        payload: events
    };
};
